module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page014"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_1"
    }
  }, [_vm._v("BAGUETTE")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_2"
    }
  }, [_vm._v("TIME REQUIRED: "), _c('span', {
    staticClass: "page014_2a"
  }, [_vm._v("1 hour")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_3"
    }
  }, [_vm._v("‘B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("aguette")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("is the")]), _vm._v(" French word for a stick, most likely a reference")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_4"
    }
  }, [_vm._v("+ 6 hours resting time")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_5"
    }
  }, [_vm._v("to its long and slender shape.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_6"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_6a"
    }
  }, [_c('span', {
    staticClass: "page014_6a"
  }, [_vm._v(" Combine the dry ingredients well, add the water and mix")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_7"
    }
  }, [_vm._v("Makes 6")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_8"
    }
  }, [_vm._v("thoroughly. Use a hand mixer [fitted with a dough hook] to")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_9"
    }
  }, [_vm._v("1 kg plain flour")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_10"
    }
  }, [_vm._v("knead the dough until it is smooth and comes away from the side")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_11"
    }
  }, [_vm._v("2 sachets dry yeast")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_12"
    }
  }, [_vm._v("of the bowl. Dust the dough with a little flour, cover with a cloth")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_13"
    }
  }, [_vm._v("750 ml lukewarm water")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_14"
    }
  }, [_vm._v("and rest in a warm place for about 6 hours.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_15"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_15a"
    }
  }, [_c('span', {
    staticClass: "page014_15a"
  }, [_vm._v(" On a floured pastry board, knead the dough well and divide")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_16"
    }
  }, [_vm._v("3–4 tsp salt")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_17"
    }
  }, [_vm._v("into 6 pieces. Knead each piece again and roll up into a sausage.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_18"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_18a"
    }
  }, [_c('span', {
    staticClass: "page014_18a"
  }, [_vm._v(" Line baking trays with baking parchment and lay 3 baguettes")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_19"
    }
  }, [_vm._v("on each tray with the join tucked underneath. Cover again and")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_20"
    }
  }, [_vm._v("rest for 10 minutes. Preheat the oven to 240°C/475°F/gas 9.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_21"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_21a"
    }
  }, [_c('span', {
    staticClass: "page014_21a"
  }, [_vm._v(" Slash each baguette several times along its length on the")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_22"
    }
  }, [_vm._v("diagonal with a sharp knife and brush with water. With the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_23"
    }
  }, [_vm._v("oven shelf on the second position from the bottom, bake for 15")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_24"
    }
  }, [_vm._v("minutes. Then lower the temperature to 200°C/400°F/gas 6 and")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_25"
    }
  }, [_vm._v("bake for 30 more minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_26"
    }
  }, [_vm._v("Tip:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_26a"
    }
  }, [_c('span', {
    staticClass: "page014_26a"
  }, [_vm._v("Baguettes are traditionally only made using wheat flour,")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_27"
    }
  }, [_vm._v("yeast, water and salt. For a little variety, the only additional")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_28"
    }
  }, [_vm._v("ingredients allowed are less than two per cent broad bean flour,")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_29"
    }
  }, [_vm._v("soya flour or malted wheat flour.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_30"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page014_0"
    }
  }, [_vm._v("14")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e9af815","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_014.vue
// module id = 96
// module chunks = 0